import { ThirdPartyInfoEstimation } from './third-party-info/third-party-info-estimation.class';
export class SmartphotoThirdPartyInfo {
    estimation;
    constructor(estimation) {
        this.estimation = new ThirdPartyInfoEstimation(estimation);
    }
}
